"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var react_1 = __importDefault(require("react"));
var tooltip_1 = __importDefault(require("../../plugins/tooltip"));
var progress_bar_1 = __importDefault(require("./progress-bar"));
var ProgressToShippingThresholdBar = function (_a) {
    var phases = _a.phases, currentValueDollars = _a.currentValueDollars, tooltipText = _a.tooltipText;
    var sortedPhases = __spreadArray([], __read(phases), false).sort(function (a, b) { return a.outOfDollars - b.outOfDollars; });
    var currentPhase = (function () {
        var e_1, _a;
        try {
            for (var sortedPhases_1 = __values(sortedPhases), sortedPhases_1_1 = sortedPhases_1.next(); !sortedPhases_1_1.done; sortedPhases_1_1 = sortedPhases_1.next()) {
                var phase = sortedPhases_1_1.value;
                if (currentValueDollars <= phase.outOfDollars)
                    return phase;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sortedPhases_1_1 && !sortedPhases_1_1.done && (_a = sortedPhases_1.return)) _a.call(sortedPhases_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return sortedPhases[sortedPhases.length - 1];
    })();
    var progressBarValues = [{ value: currentValueDollars, color: currentPhase.color }];
    var dollarsUntilThreshold = (0, currency_js_1.default)(currentPhase.outOfDollars).subtract(currentValueDollars).value;
    var textEl = dollarsUntilThreshold >= 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        "You\u2019re ", "$".concat((0, currency_js_1.default)(dollarsUntilThreshold)),
        " away from ",
        react_1.default.createElement("span", { style: { color: currentPhase.color, fontWeight: 800 } }, currentPhase.notYetText),
        "! (Save $",
        currentPhase.shippingPrice,
        "!)")) : (react_1.default.createElement(react_1.default.Fragment, null,
        "Congrats! You\u2019ve unlocked ",
        react_1.default.createElement("span", { style: { color: currentPhase.color, fontWeight: 800 } }, currentPhase.achievedText),
        "!"));
    return (react_1.default.createElement("div", { className: 'width-100 height-100 flex-container flex-dir-column align-middle' },
        react_1.default.createElement("div", { className: 'h-3 width-100' },
            react_1.default.createElement(progress_bar_1.default, { values: progressBarValues, outOf: currentPhase.outOfDollars, outerStyle: { borderWidth: 1, borderStyle: 'solid' } })),
        react_1.default.createElement("div", { className: 'h-2' }),
        react_1.default.createElement("div", { className: 'text-xs', style: { fontWeight: 500 } },
            textEl,
            tooltipText && (react_1.default.createElement(react_1.default.Fragment, null,
                "\u00A0",
                react_1.default.createElement(tooltip_1.default, { button: react_1.default.createElement("i", { className: 'ss-info text-sm', style: { verticalAlign: 'middle' } }) },
                    react_1.default.createElement("div", { className: 'padding-vertical-1 padding-right-8' }, tooltipText)))))));
};
exports.default = ProgressToShippingThresholdBar;
